import { Stack } from "@mui/material";
import { type FC } from "react";

import {
  CardsCarousel,
  CardsCarouselSlide,
} from "~/components/UI/CardsCarousel";
import { EventSectionTitle } from "~/feature/event/components/EventSectionTitle";
import { NewsCard } from "~/feature/news/components/NewsCard";
import type { INewsArticle } from "~/types/newsArticle";

interface INewsCarouselProps {
  header: string;
  articles: INewsArticle[];
}

export const NewsCarousel: FC<INewsCarouselProps> = ({ header, articles }) => {
  return (
    <Stack sx={{
      gap: 1.5
    }}>
      <EventSectionTitle>{header}</EventSectionTitle>

      <CardsCarousel>
        {articles.map((article) => (
          <CardsCarouselSlide key={article.id}>
            <NewsCard article={article} />
          </CardsCarouselSlide>
        ))}
      </CardsCarousel>
    </Stack>
  );
};
